export function encodeRequest(data) {
    return Object.keys(data)
        .map(function (key) { return [encodeURIComponent(key), encodeURIComponent(data[key])]; })
        .map(function (pair) { return pair.join('='); })
        .join('&');
}
export function decodeResponse(body) {
    try {
        var data = JSON.parse(body);
        if (data && data.status) {
            return data;
        }
        return {
            status: 'error',
            description: 'Unknown response'
        };
    }
    catch (e) {
        return {
            status: 'error',
            description: 'Error response decoding'
        };
    }
}
export default function buildUrl(url, params) {
    if (params === void 0) { params = {}; }
    var encodedParams = encodeParams(params);
    if (encodedParams.length) {
        return url + "?" + encodedParams.join('&');
    }
    return url;
}
function encodeParams(params) {
    return Object.keys(params).reduce(function (res, key) {
        var value = params[key];
        if (value !== null && value !== undefined) {
            res.push(key + "=" + encodeURIComponent(value));
        }
        return res;
    }, []);
}
